import { SvgIcon } from '@mui/material'

export const MovingIcon = () => {
  return (
    <SvgIcon
      sx={{ width: '24px', height: '24px' }}
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#MovingIcon)">
        <path
          fill="#FFBE5D"
          d="m16 6 2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6h-6Z"
        />
      </g>
      <defs>
        <clipPath id="MovingIcon">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </SvgIcon>
  )
}
